import { useAppSelector } from "@/redux/store";
import { record_PageVisit } from "@/services";
import { buildPageCatalog } from "@/utils/router";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires one RecordPageVisit call per route change, resolving the page key from the
 * same menuConfig catalog useCopilotPageContext uses. Fire-and-forget: a failed
 * telemetry call must never surface to the user, so rejections are swallowed here
 * rather than left to the shared http layer's error toast.
 */
export function usePageVisitLogger() {
  const { pathname } = useLocation();
  const { menuConfig } = useAppSelector(state => state.router);

  const catalog = useMemo(() => buildPageCatalog(menuConfig), [menuConfig]);

  useEffect(() => {
    const page = catalog.find(entry => entry.path === pathname);
    if (!page) return;
    record_PageVisit({ pageKey: page.pageKey, path: pathname }).catch(() => undefined);
  }, [pathname, catalog]);
}
